import { render, staticRenderFns } from "./DynamicHome.vue?vue&type=template&id=0fee3686"
import script from "./DynamicHome.vue?vue&type=script&lang=js"
export * from "./DynamicHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports